// import { receiveServerErrors } from '../errors/error_actions'
import Cookies from "js-cookie";
import initialSpeechReportSelectedFilters from "./SpeechReport/initialSpeechReportSelectedFilters";

export const RECEIVE_REPORTS = "RECEIVE_REPORTS";
export const UPDATE_TAB = "UPDATE_TAB";
export const REPORT_PAGE_STATES = "REPORT_PAGE_STATES";
export const UPDATE_SPEECH_REPORT_TAB = "UPDATE_SPEECH_REPORT_TAB";
export const UPDATE_SPEECH_REPORT_DATA = "UPDATE_SPEECH_REPORT_DATA";
export const UPDATE_SPEECH_REPORT_FILTERS = "UPDATE_SPEECH_REPORT_FILTERS";
export const UPDATE_SPEECH_REPORT_DURATION = "UPDATE_SPEECH_REPORT_DURATION";
export const UPDATE_SPEECH_REPORT_HIGHLIGHT = "UPDATE_SPEECH_REPORT_HIGHLIGHT";
const lodash = require("lodash");

const receiveReports = (reports) => ({ type: RECEIVE_REPORTS, reports });
export const updateTab = (tab, tabClicked) => ({
  type: UPDATE_TAB,
  tab,
  tabClicked,
});

export const updateReportPageState = (status) => ({
  type: REPORT_PAGE_STATES,
  status,
});

const { REACT_APP_BASE_URL } = process.env;
const brand_id = Cookies.get("bId");
const user_id = Cookies.get("uId");

export const fetchReports = (tab) => (dispatch) => {
  $.ajax({
    method: "get",
    url: `${REACT_APP_BASE_URL}/jwt_api/reports`,
    data: { tab, brand_id: Cookies.get("bId"), user_id: Cookies.get("uId") },
    success(reports) {
      dispatch(receiveReports(reports));
    },
    // error({ responseJSON, statusText }) {
    //   dispatch(receiveServerErrors(responseJSON || [statusText]))
    // },
  });
};

export const fetchSpeechReport = (
  filters,
  duration = "6m",
  // page = 1,
  highlight,
  start_date = "",
  end_date = "",
  cluster = "video",
  cluster_sort_by = "youtube_published_at",
  desc = true
) =>
  new Promise((resolve, reject) => {
    $.ajax({
      method: "get",
      url: `${REACT_APP_BASE_URL}/jwt_api/reports/speech_reports`,
      data:
        // !lodash.isEqual(filters, initialSpeechReportSelectedFilters)
        // ? {
        //     // filters,
        //     duration,
        //     page,
        //     highlight,
        //     // cluster,
        //     // cluster_sort_by,
        //     desc,
        //     brand_id: Cookies.get("bId"),
        //     user_id: Cookies.get("uId"),
        //   }
        // :
        {
          filters,
          duration,
          // page,
          highlight,
          start_date,
          end_date,
          cluster,
          cluster_sort_by,
          desc,
          brand_id: Cookies.get("bId"),
          user_id: Cookies.get("uId"),
        },
      success(response) {
        resolve(response);
      },
      error(xhr) {
        reject(xhr);
      },
    });
  });

export const updateSpeechReportHighlight = (highlight) => ({
  type: UPDATE_SPEECH_REPORT_HIGHLIGHT,
  highlight,
});

export const updateSpeechReportTab = (tab) => ({
  type: UPDATE_SPEECH_REPORT_TAB,
  tab,
});

export const updateSpeechReportData = (data) => ({
  type: UPDATE_SPEECH_REPORT_DATA,
  data,
});

export const updateSpeechReportFilters = (selectedFilters) => ({
  type: UPDATE_SPEECH_REPORT_FILTERS,
  selectedFilters,
});

export const updateSpeechReportDuration = (duration) => ({
  type: UPDATE_SPEECH_REPORT_DURATION,
  duration,
});
